// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** function to get dimensions
  usage example to get \`tablet\` value from \`\$page-max-widths\`
  .class {
    max-width: dim(\$page-max-widths, tablet);
  }

 */
.contact-boxout-module__container___SF8wY {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  background-color: var(--surface1, #fff);
}

.contact-boxout-module__flip-icon___D0CmE {
  transform: scaleY(-1);
}

.contact-boxout-module__icon___i1gzw {
  width: 22px;
  height: 22px;
  transition: 0.1s ease-out transform;
}
.contact-boxout-module__icon___i1gzw svg {
  width: 22px;
  height: 22px;
  fill: var(--primary600, #4b286d);
}
.contact-boxout-module__icon___i1gzw svg path:last-child {
  fill: var(--primary600, #4b286d);
}
.contact-boxout-module__icon--flip___p_IYm {
  transform: rotate(-180deg);
}

.contact-boxout-module__list___R7AyX {
  position: relative;
}
.contact-boxout-module__list-dropdown___TuGDI {
  color: var(--neutral100, #2c2e30) !important;
  margin: 0 !important;
  text-decoration: none !important;
}
.contact-boxout-module__list-item___AoC11 {
  width: 100%;
  border: none;
  background-color: transparent;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  position: relative;
  padding: 0;
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 500;
  font-size: 1rem;
  color: var(--primary600, #4b286d);
  cursor: pointer;
  text-transform: capitalize;
  text-align: start;
  text-decoration: underline;
}
.contact-boxout-module__list-item___AoC11:focus {
  outline: var(--focus, #2681e1) solid 2px;
  outline-offset: 3px;
}
.contact-boxout-module__list-item___AoC11:focus {
  outline-offset: -4px;
}
.contact-boxout-module__list-item___AoC11:hover {
  background-color: var(--neutral15);
}

.contact-boxout-module__children___zwzMx {
  display: flex;
  flex-direction: column;
  flex: 1;
}`, "",{"version":3,"sources":["webpack://./node_modules/wa-storybook/styles/tools/functions/_widths.scss","webpack://./client/app/react-components/contact-boxout/contact-boxout.module.scss","webpack://./node_modules/wa-storybook/styles/tools/mixins/_focus-outline.scss"],"names":[],"mappings":"AAAA;;;;;;EAAA;ACEA;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,uCAAA;AAMF;;AAHA;EACE,qBAAA;AAMF;;AAHA;EACE,WAAA;EACA,YAAA;EACA,mCAAA;AAMF;AAJE;EACE,WAAA;EACA,YAAA;EACA,gCAAA;AAMJ;AAJI;EACE,gCAAA;AAMN;AAFE;EACE,0BAAA;AAIJ;;AAAA;EACE,kBAAA;AAGF;AADE;EACE,4CAAA;EACA,oBAAA;EACA,gCAAA;AAGJ;AAAE;EACE,WAAA;EACA,YAAA;EACA,6BAAA;EACA,wBAAA;KAAA,qBAAA;UAAA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;EACA,eAAA;EACA,0BAAA;EACA,iBAAA;EACA,0BAAA;AAEJ;ACxDI;EACE,wCAAA;EACA,mBAAA;AD0DN;AAHI;EACE,oBAAA;AAKN;AAFI;EACE,kCAAA;AAIN;;AACA;EACE,aAAA;EACA,sBAAA;EACA,OAAA;AAEF","sourcesContent":["/** function to get dimensions\n  usage example to get `tablet` value from `$page-max-widths`\n  .class {\n    max-width: dim($page-max-widths, tablet);\n  }\n\n */\n\n@function dim($prop, $key) {\n  @return map-get($prop, $key);\n}\n","@import '~wa-storybook/styles/utils.scss';\n\n.container {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  background-color: color(surface1);\n}\n\n.flip-icon {\n  transform: scaleY(-1);\n}\n\n.icon {\n  width: 22px;\n  height: 22px;\n  transition: 0.1s ease-out transform;\n\n  svg {\n    width: 22px;\n    height: 22px;\n    fill: color(primary600);\n\n    path:last-child {\n      fill: color(primary600);\n    }\n  }\n\n  &--flip {\n    transform: rotate(-180deg);\n  }\n}\n\n.list {\n  position: relative;\n\n  &-dropdown {\n    color: color(neutral100) !important;\n    margin: 0 !important;\n    text-decoration: none !important;\n  }\n\n  &-item {\n    width: 100%;\n    border: none;\n    background-color: transparent;\n    appearance: none;\n    position: relative;\n    padding: 0;\n    margin-top: 16px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-weight: 500;\n    font-size: rem(16);\n    color: color(primary600);\n    cursor: pointer;\n    text-transform: capitalize;\n    text-align: start;\n    text-decoration: underline;\n    @include focus-outline;\n\n    &:focus {\n      outline-offset: -4px;\n    }\n\n    &:hover {\n      background-color: color(neutral15);\n    }\n  }\n}\n\n.children {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n","@import '../functions/color';\n\n@mixin focus-outline($color: color(focus), $applyDirectly: false) {\n  @if $applyDirectly {\n    outline: $color solid 2px;\n    outline-offset: 3px;\n  } @else {\n    &:focus {\n      outline: $color solid 2px;\n      outline-offset: 3px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `contact-boxout-module__container___SF8wY`,
	"flip-icon": `contact-boxout-module__flip-icon___D0CmE`,
	"icon": `contact-boxout-module__icon___i1gzw`,
	"icon--flip": `contact-boxout-module__icon--flip___p_IYm`,
	"list": `contact-boxout-module__list___R7AyX`,
	"list-dropdown": `contact-boxout-module__list-dropdown___TuGDI`,
	"list-item": `contact-boxout-module__list-item___AoC11`,
	"children": `contact-boxout-module__children___zwzMx`
};
export default ___CSS_LOADER_EXPORT___;
